import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { Col, Row, Button, Form, FormGroup, Label, Input } from "reactstrap";
import axios from "axios";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";

function ClientesCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_AREAS = process.env.REACT_APP_URL_AREAS;
  const URL_EMPRESAS = process.env.REACT_APP_URL_EMPRESAS;
  const URL_COLABORADORES = process.env.REACT_APP_URL_COLABORADORES;
  // const [text, setText] = useState(false);

  const [nombre_comercial, setNombreComercial] = useState("");
  const [razon_social, setRazonSocial] = useState("NA");
  const [RFC, setRFC] = useState("NA");
  const [calle, setCalle] = useState("NA");
  const [numero_ext, setNumeroExt] = useState("NA");
  const [numero_int, setNumeroInt] = useState("NA");
  const [delegacion, setDelegacion] = useState("NA");
  const [estado, setEstado] = useState("CIUDAD DE MEXICO");
  const [pais, setPais] = useState("Mexico");
  const [cp, setCP] = useState("0");
  const [colonia, setColonia] = useState("NA");
  // const [codigo, setCodigo] = useState("");
  const [ciudad, setCiudad] = useState("NA");
  const [plazo, setPlazo] = useState("0");
  const [telefono, setTelefono] = useState("");
  const [telefonoCobranza, setTelefonoCobranza] = useState("");
  const [telefonoCompras, setTelefonoCompras] = useState("");
  const [encargadaPagos, setEncargadaPagos] = useState("");
  const [email, setEmail] = useState("a@b.a");
  const [selectedGrupo, setSelectedGrupo] = useState("661ef68156c8b678381cee58");
  const [selectedDepartamento, setSelectedDepartamento] = useState("67d1c09b26ef66003c37cbe1");
  const [selectedArea, setSelectedArea] = useState("6201b18c0f94f86068a741c0");
  const [selectedVendedor, setSelectedVendedor] = useState("");
  const [observaciones, setObservaciones] = useState("NA");
  const [forma_pago, setFormaPago] = useState("Contado");
  const [alertasVentas, setAlertasVentas] = useState("Si");
  const [alertasEdoCta, setAlertasEdoCta] = useState("Si");
  const [alertasMarketing, setAlertasMarketing] = useState("Si");
  const [empresas, setEmpresas] = useState([]);
  const [selectedEmpresa, setSelectedEmpresa] = useState("");
  const [colaboradores, setColaboradores] = useState([]);
  const [areas, setAreas] = useState([]);
  const [regFiscal, setRegFiscal] = useState("");
  const [usoCFDI, setusoCFDI] = useState("");
  const [formaPagoSAT, setFormaPagoSAT] = useState("");
  const [condicionesPagoSAT, setCondicionesPagoSAT] = useState("");
  const [metodoPagoSAT, setMetodoPagoSAT] = useState("");

  const [validaBoton, setValidaBoton] = useState(true);

  useEffect(() => {
    axios
    .get(URL_EMPRESAS, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((res) => {
      const allEmpresas = res.data;
      setEmpresas(allEmpresas);
    })
    .catch((err) => {
      console.log(err);
    })
    axios
    .get(URL_AREAS, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((res) => {
      const allAreas = res.data;
      setAreas(allAreas);
    })
    .catch((err) => {
      console.log(err);
    })
    axios
      .get(URL_COLABORADORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allColaboradores = res.data;
        setColaboradores(allColaboradores);
      })
      .catch((err) => {
        console.log(err);
      });
  },[])


  const saveClientes = async (event) => {
    event.preventDefault();
    setValidaBoton(false);
    try {
      await axios
        .post(
          URL_CLIENTES,
          {
            nombre_comercial,
            razon_social,
            RFC,
            calle,
            numero_ext,
            numero_int,
            delegacion,
            estado,
            pais,
            cp,
            colonia,
            ciudad,
            telefono,
            telefonoCobranza,
            telefonoCompras,
            encargadaPagos,
            email,
            grupos: selectedGrupo,
            departamentosClientes: selectedDepartamento,
            vendedor: selectedVendedor,
            observaciones,
            ultimo_pago: "2000-01-01",
            forma_pago,
            // codigo,
            calificadora: 1,
            areas: selectedArea,
            plazo,
            cargos:0,
            abonos:0,
            saldo:0,
            alertasVentas,
            alertasEdoCta,
            alertasMarketing,
            empresas: selectedEmpresa,
            cargosk: 0,
            abonosk: 0,
            saldok: 0,
            usoCFDI,
            regFiscal,
            formaPagoSAT,
            condicionesPagoSAT,
            metodoPagoSAT,
            fiscal:"No",
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
            .then(() => {
              axios.post(
                URL_LOGS,
                {
                  tipo: "Crear Cliente",
                  detalle: `${nombre_comercial}`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              );
              Swal.fire("Good job!", "Creado con exito", `success`);
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                footer: `${error.response.data.message}`,
              });
              console.log(error);
              setValidaBoton(true);
            });
        
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${error.response.data.message}`,
      });
      console.log(error);
      setValidaBoton(true);
    }
  };

  return (
    <>
      <Header />
      <br />
      <br />
      {user.clientes_create ? (
        <div className="card container">
          <h3 align="center">Nuevo Cliente</h3>
          <Form onSubmit={saveClientes}>
            <Row>
              {/* <Col md={3}>
                <Label>Nombre</Label>
                <Input
                  type="text"
                  placeholder="Nombre"
                  value={nombre}
                  required
                  onChange={(e) => {
                    setNombre(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Apellido</Label>
                <Input
                  type="text"
                  placeholder="Apellido"
                  value={apellido}
                  required
                  onChange={(e) => {
                    setApellido(e.target.value);
                  }}
                />
              </Col> */}
              {/* <Col md={3}>
                <Label>Codigo</Label>
                <Input
                  type="text"
                  placeholder="Codigo"
                  value={codigo}
                  required
                  onChange={(e) => {
                    setCodigo(e.target.value);
                  }}
                />
              </Col> */}
              <Col md={3}>
                <Label>Nombre Comercial</Label>
                <Input
                  type="text"
                  placeholder="Nombre Comercial"
                  value={nombre_comercial}
                  required
                  onChange={(e) => {
                    setNombreComercial(e.target.value);
                  }}
                />
              </Col>

              <Col md={3}>
                <Label>Telefono</Label>
                <Input
                  type="text"
                  placeholder="Telefono"
                  value={telefono}
                  required
                  onChange={(e) => {
                    setTelefono(e.target.value);
                  }}
                />
              </Col>

              <Col md={3}>
              <Label>Empresa</Label>
                <Input
                  type="select"
                  value={selectedEmpresa}
                  required
                  onChange={(e) => {
                    setSelectedEmpresa(e.target.value);
                  }}
                >
                  <option value="0">Selecciona una Empresa</option>
                  {empresas
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </Col>

              <Col md={3}>
              <Label className="mr-sm-2">Almacen</Label>
              <Input
                className="col-sm-12"
                type="select"
                value={selectedArea}
                required
                onChange={(e) => {
                  setSelectedArea(e.target.value);
                }}
              >
                <option value="0">Selecciona un almacen</option>
                {areas
                        .sort((a, b) => (a.name > b.name ? 1 : -1))
                        .map((a) => {
                              return <option value={a._id}>{a.name}</option>;
                        })}
              </Input>
            </Col>

              </Row>
              <Row>
              <Col md={3}>
              <Label>Telefono Compras</Label>
                <Input
                  type="text"
                  placeholder="Telefono Compras"
                  value={telefonoCompras}
                  required
                  onChange={(e) => {
                    setTelefonoCompras(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
              <Label>Telefono Cobranza</Label>
                <Input
                  type="text"
                  placeholder="Telefono Cobranza"
                  value={telefonoCobranza}
                  required
                  onChange={(e) => {
                    setTelefonoCobranza(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
              <Label>Encargada Pagos</Label>
                <Input
                  type="text"
                  placeholder="Encargada Pagos"
                  value={encargadaPagos}
                  required
                  onChange={(e) => {
                    setEncargadaPagos(e.target.value);
                  }}
                />
              </Col>
              </Row>
              <Row>
              <Col md={3}>
                <Label>Razon Social</Label>
                <Input
                  type="text"
                  placeholder="Razon Social"
                  value={razon_social}
                  required
                  onChange={(e) => {
                    setRazonSocial(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>RFC</Label>
                <Input
                  type="text"
                  placeholder="RFC"
                  value={RFC}
                  required
                  onChange={(e) => {
                    setRFC(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label className="mr-sm-2">Vendedor</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedVendedor}
                  required
                  onChange={(e) => {
                    setSelectedVendedor(e.target.value);
                  }}
                >
                  <option value="">Selecciona un Vendedor</option>
                  {colaboradores
                    .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                    .map((a) => {
                      return (
                        <option value={a._id}>
                          {a.nombre} {a.apellido}
                        </option>
                      );
                    })}
                </Input>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Label>Calle</Label>
                <Input
                  type="text"
                  placeholder="Calle"
                  value={calle}
                  required
                  onChange={(e) => {
                    setCalle(e.target.value);
                  }}
                />
              </Col>
              <Col md={2}>
                <Label>No. Ext</Label>
                <Input
                  type="text"
                  placeholder="No. Ext"
                  value={numero_ext}
                  required
                  onChange={(e) => {
                    setNumeroExt(e.target.value);
                  }}
                />
              </Col>
              <Col md={2}>
                <Label>No. Int</Label>
                <Input
                  type="text"
                  placeholder="No. Int"
                  value={numero_int}
                  required
                  onChange={(e) => {
                    setNumeroInt(e.target.value);
                  }}
                />
              </Col>
              <Col md={2}>
                <Label>Pais</Label>
                <Input
                  type="text"
                  placeholder="Pais"
                  value={pais}
                  required
                  onChange={(e) => {
                    setPais(e.target.value);
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col md={3}>
                <Label>Estado</Label>
                <Input
                  type="select"
                  value={estado}
                  required
                  onChange={(e) => {
                    setEstado(e.target.value);
                  }}
                >
                  <option value="">Selecciona</option>

                  <option value="AGUASCALIENTES">AGUASCALIENTES</option>
                  <option value="BAJA CALIFORNIA NORTE">BAJA CALIFORNIA NORTE</option>
                  <option value="BAJA CALIFORNIA SUR">BAJA CALIFORNIA SUR</option>
                  <option value="CAMPECHE">CAMPECHE</option>
                  <option value="CHIAPAS">CHIAPAS</option>
                  <option value="CHIHUAHUA">CHIHUAHUA</option>
                  <option value="CIUDAD DE MEXICO">CIUDAD DE MEXICO</option>
                  <option value="COAHUILA">COAHUILA</option>
                  <option value="COLIMA">COLIMA</option>
                  <option value="DURANGO">DURANGO</option>
                  <option value="ESTADO DE MEXICO">ESTADO DE MEXICO</option>
                  <option value="GUANAJUATO">GUANAJUATO</option>
                  <option value="GUERRERO">GUERRERO</option>
                  <option value="HIDALGO">HIDALGO</option>
                  <option value="JALISCO">JALISCO</option>
                  <option value="MICHOACAN">MICHOACAN</option>
                  <option value="MORELOS">MORELOS</option>
                  <option value="NAYARIT">NAYARIT</option>
                  <option value="NUEVO LEON">NUEVO LEON</option>
                  <option value="OAXACA">OAXACA</option>
                  <option value="PUEBLA">PUEBLA</option>
                  <option value="QUERETARO">QUERETARO</option>
                  <option value="QUINTANA ROO">QUINTANA ROO</option>
                  <option value="SAN LUIS POTOSI ">SAN LUIS POTOSI</option>
                  <option value="SINALOA">SINALOA</option>
                  <option value="SONORA">SONORA</option>
                  <option value="TABASCO">TABASCO</option>
                  <option value="TAMAULIPAS">TAMAULIPAS</option>
                  <option value="TLAXCALA">TLAXCALA</option>
                  <option value="VERACRUZ">VERACRUZ</option>
                  <option value="YUCATAN">YUCATAN</option>
                  <option value="ZACATECAS">ZACATECAS</option>
                  </Input>
              </Col>
              <Col md={3}>
                <Label>Ciudad</Label>
                <Input
                  type="text"
                  placeholder="Ciudad"
                  value={ciudad}
                  required
                  onChange={(e) => {
                    setCiudad(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Delegacion</Label>
                <Input
                  type="text"
                  placeholder="Delegacion o Municipio"
                  value={delegacion}
                  required
                  onChange={(e) => {
                    setDelegacion(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Colonia</Label>
                <Input
                  type="text"
                  placeholder="Colonia"
                  value={colonia}
                  required
                  onChange={(e) => {
                    setColonia(e.target.value);
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col md={3}>
                <Label>CP</Label>
                <Input
                  type="text"
                  placeholder="CP"
                  value={cp}
                  required
                  onChange={(e) => {
                    setCP(e.target.value);
                  }}
                />
              </Col>
             
              <Col md={3}>
                <Label>Email</Label>
                <Input
                  type="email"
                  placeholder="Email"
                  value={email}
                  required
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                />
              </Col>
             
            </Row>
            <Row>
            <Col md={3}>
                <Label className="mr-sm-2">Alertas Ventas</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={alertasVentas}
                  required
                  onChange={(e) => {
                    setAlertasVentas(e.target.value);
                  }}
                >
                  <option value="">Selecciona</option>
                  <option value="Si">Si</option>
                  <option value="No">No</option>
                </Input>
              </Col>
              <Col md={3}>
                <Label className="mr-sm-2">Alertas Estado Cuenta</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={alertasEdoCta}
                  required
                  onChange={(e) => {
                    setAlertasEdoCta(e.target.value);
                  }}
                >
                  <option value="">Selecciona</option>
                  <option value="Si">Si</option>
                  <option value="No">No</option>
                </Input>
              </Col>
              <Col md={3}>
                <Label className="mr-sm-2">Alertas Marketing</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={alertasMarketing}
                  required
                  onChange={(e) => {
                    setAlertasMarketing(e.target.value);
                  }}
                >
                  <option value="">Selecciona</option>
                  <option value="Si">Si</option>
                  <option value="No">No</option>
                </Input>
              </Col>
            </Row>


            <Row>
            <Col md={3}>
                <Label>Regimen Fiscal</Label>
                <Input
                  type="select"
                  placeholder="RegFiscal"
                  value={regFiscal}
                  required
                  onChange={(e) => {
                    setRegFiscal(e.target.value);
                  }}
                >
                <option value="">Selecciona</option>
                  <option value="0">0</option>
                  <option value="601">601 General de Ley Personas Morales</option>
                  <option value="603">603 Personas Morales con Fines no Lucrativos</option>
                  <option value="605">605 Sueldos y Salarios e Ingresos Asimilados al Salario</option>
                  <option value="608">608 Demas Ingresos</option>
                  <option value="612">612 Personas Físicas con Actividades Empresariales y Profesionales</option>
                  <option value="616">616 Sin Obligacion Fiscal</option>
                  <option value="621">621 Incorporacion Fiscal</option>
                  <option value="624">624 Régimen de los Coordinados</option>
                  <option value="625">625 Reg. de las act. emp. cpn ingresos a traves de plat. tec.</option>
                  <option value="626">626 Regimen simplificado de Confianza</option>
                </Input>
              </Col>

              <Col md={3}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Uso de CDFI
                </Label>
                <Input
                  type="select"
                  placeholder="Uso de CDFI"
                  value={usoCFDI}
                  required
                  onChange={(e) => {
                    setusoCFDI(e.target.value);
                  }}
                >
                <option value="">Selecciona</option>
                  <option value="G01">G01 Adquisición de mercancías</option>
                  <option value="G03">G03 Gastos en general</option>
                  <option value="S01">S01 Sin efectos fiscales</option>
                  </Input>
              </Col>
              <Col md={3}>
                <Label>Forma Pago Fiscal</Label>
                <Input
                  type="select"
                  value={formaPagoSAT}
                  required
                  onChange={(e) => {
                    setFormaPagoSAT(e.target.value);
                  }}
                >
              <option value="">Selecciona</option>
              <option value="01"> 01 Efectivo</option>
              <option value="02"> 02 Cheque nominativo</option>
              <option value="03"> 03 Transferencia electrónica de fondos</option>
              <option value="04"> 04 Tarjeta de crédito</option>
              <option value="05"> 05 Monedero electrónico</option>
              <option value="06"> 06 Dinero electrónico</option>
              <option value="08"> 08 Vales de despensa</option>
              <option value="12"> 12 Dación en pago</option>
              <option value="13"> 13 Pago por subrogación</option>
              <option value="14"> 14 Pago por consignación</option>
              <option value="15"> 15 Condonación</option>
              <option value="17"> 17 Compensación</option>
              <option value="23"> 23 Novación</option>
              <option value="24"> 24 Confusión</option>
              <option value="25"> 25 Remisión de deuda</option>
              <option value="26"> 26 Prescripción o caducidad</option>
              <option value="27"> 27 A satisfacción del acreedor</option>
              <option value="28"> 28 Tarjeta de débito</option>
              <option value="29"> 29 Tarjeta de servicios</option>
              <option value="30"> 30 Aplicación de anticipos</option>
              <option value="99"> 99 Por definir</option>
                </Input>
              </Col>

              <Col md={3}>
                <Label>Metodo Pago Fiscal</Label>
                <Input
                  type="select"
                  value={metodoPagoSAT}
                  required
                  onChange={(e) => {
                    setMetodoPagoSAT(e.target.value);
                  }}
                >

              <option value="">Selecciona</option>
              <option value="PUE">PUE (Pago de Una Sola Exhibición)</option>
              <option value="PPD">PPD (Pago en Parcialidades o Diferido)</option>
                </Input>
              </Col>

              <Col md={3}>
                <Label>Condiciones de Pago Fiscal</Label>
                <Input
                  type="text"
                  value={condicionesPagoSAT}
                  required
                  onChange={(e) => {
                    setCondicionesPagoSAT(e.target.value);
                  }}
                />
              </Col>
            </Row>
            
            <br />
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
            <Button
              href="/Clientes"
              className="btn btn-danger"
              id="botonListado"
            >
              Regresar
            </Button>
          </Form>
          <br />
        </div>
      ) : undefined}
      
    </>
  );
}

export default ClientesCreate;
